// Indicator.js
import React from "react";
import "../assets/Indicator.css"; // Import the CSS for styling

const Indicator = ({
  isPomodoroMode, 
  currentSetting, 
  brightnessFactor = 1, 
  isDeviceOn,
  volume }) => {
  return (
      <div 
      className="indicatorContainer"
      style={{
      filter: `brightness(${brightnessFactor})`,
      display: isDeviceOn ? "block" : "none"
      }}
      >
        <img src="/icons/i_battery.svg" alt="Battery Indicator" className="indicatorIcon" />
        {/* Pomodoro Mode Indicator */}
        <img
        src="/icons/i_pomodormode.svg"
        alt="Pomodoro Mode Indicator"
        className={`indicatorIcon ${isPomodoroMode ? "pomodoroActive" : "hidden"}`}
        />
        <img 
          src="/icons/i_volumeMax.svg" 
          alt="Volume Max Indicator"
          className= "volumeIcons volumeMax"
          style={{
            display: volume === 4 | volume === 5 ? "block" : "none"}} 
        />
        <img 
          src="/icons/i_volumeLow.svg"
          alt="Volume Low Indicator" 
          className="volumeIcons volumeLow"
          style={{
            display: volume === 2 | volume === 3 ? "block" : "none"}}  
        />
        <img 
          src="/icons/i_volumeMute.svg" 
          alt="Volume Mute Indicator" 
          className="volumeIcons volumeMute" 
          style={{
            display: volume === 1 ? "block" : "none"}} 
        />
        
        
        <img
          src="/icons/i_volumeLow.svg"
          alt="Settings Volume Indicator"
          className={`indicatorIcon ${
            currentSetting === 2 ? "volumeActive" : "hidden"
          }`}
        />
        <img
          src="/icons/i_lightbulb.svg"
          alt="Settings Brightness Indicator"
          className={`indicatorIcon ${
            currentSetting === 1 ? "brightnessActive" : "hidden"
          }`}
        />
        <img
          src="/icons/i_sound.svg"
          alt="Settings Tone Indicator"
          className={`indicatorIcon ${
            currentSetting === 3 ? "toneActive" : "hidden"
          }`}
        />

        {/* Focus and Rest labels as indicators */}
      
        <img src="/icons/i_focus.svg" alt="Focus Timer" className="timerLabelFocus" />
      
        <img src="/icons/i_break.svg" alt="Rest Timer" className="timerLabelBreak" />
       
      </div>
  );
};

export default Indicator;
